class MatchHeight {
	constructor() {
		this.containers = document.querySelectorAll("[data-mh-container]");
		if (this.containers.length) {
			this.init();
			resizeCallbacks.push(this);
		}
	}

	init() {

		let mm = gsap.matchMedia();

		mm.add("(min-width: 992px)", () => {

			this.containers.forEach(container => {
				const items = container.querySelectorAll("[data-mh]");
				let maxHeight = 0;

				gsap.set(items, {
					height: "auto"
				});

				items.forEach(inner => {
					if (inner.clientHeight > maxHeight) {
						maxHeight = inner.clientHeight;
					}
				});

				gsap.set(items, {
					height: maxHeight
				});
			});

			return () => { // optional
				this.containers.forEach(container => {
					const items = container.querySelectorAll("[data-mh]");
					gsap.set(items, {
						height: "auto"
					});
				});
			};

		});

	}

	resize() {
		this.init();
	}
}